import { Component } from '@angular/core';

@Component({
  selector: 'empathy-heatmap-description',
  templateUrl: 'heatmap-description.component.html',
  styleUrls: ['./heatmap-description.component.scss']
})
export class HeatmapDescriptionComponent {}
